export const showRegistration = process.env.REACT_APP_REGISTRATION === 'true';
